import { useDialog } from "@platform/store";
import { VideoMeetingDialogTypes } from "../../videoMeeting.types";
import { VideoMeetingEndDialog } from "../../dialogs/VideoMeetingEndDialog/VideoMeetingEndDialog";

export function VideoMeetingDialogs() {
  const { activeDialog } = useDialog();

  if (!["endMeeting"].includes(activeDialog || "")) {
    return null;
  }

  switch (activeDialog as VideoMeetingDialogTypes) {
    case "endMeeting":
      return <VideoMeetingEndDialog />;
    default:
      return null;
  }
}

export default VideoMeetingDialogs;
